import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import {
    Collapse,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@mui/material'
import usePrefixPath from 'hooks/usePrefixPath/usePrefixPath'
import { values } from 'lodash-es'
import { CurrentClientContract } from 'models'
import { Show } from 'permission/Show'
import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { AdminNav, IMenu, IMenuNav } from './SideNavigation'
import { tid } from 'utilities/e2e/e2eUtils'
interface MenuGroupProps {
    menu: IMenu
    onClickMenu: (menu: IMenuNav) => void
    currentClient: CurrentClientContract | undefined
    hasOpenned?: boolean
}

function MenuSubItem(props: {
    subMenu: IMenuNav
    onClickMenu: (sub: IMenuNav) => void
    currentClient: CurrentClientContract | undefined
}) {
    const { selectedPath } = usePrefixPath()
    const location = useLocation()
    return (
        <Show
            when={props.subMenu.requirePermission}
            moduleName={props.subMenu.moduleName}
        >
            <AdminNav
                sx={{
                    background: 'inherit',
                }}
                component="div"
                disablePadding
            >
                <ListItemButton
                    data-testid={tid(props.subMenu.title, 'sidebar')}
                    sx={{
                        background: 'inherit',
                    }}
                    onClick={() => props.onClickMenu(props.subMenu)}
                    selected={selectedPath(
                        location.pathname,
                        props.subMenu.path,
                    )}
                    disabled={
                        props.subMenu.disabled ||
                        (props.subMenu.visibleToClientType &&
                            (!props.currentClient ||
                                !props.subMenu.visibleToClientType.includes(
                                    props.currentClient.type!,
                                )))
                    }
                >
                    <ListItemIcon>
                        <Typography
                            color={
                                selectedPath(
                                    location.pathname,
                                    props.subMenu.path,
                                )
                                    ? 'primary.contrastText'
                                    : 'inherit'
                            }
                        >
                            {props.subMenu.icon}
                        </Typography>
                    </ListItemIcon>
                    <ListItemText primary={props.subMenu.title} />
                </ListItemButton>
            </AdminNav>
        </Show>
    )
}

const MenuGroup = ({
    menu,
    onClickMenu,
    currentClient,
    hasOpenned = false,
}: MenuGroupProps) => {
    const navs = useMemo(() => values(menu.navs) ?? [], [menu])

    const [openSubMenu, setOpenSubMenu] = React.useState(
        hasOpenned || menu.displayFirst,
    )

    const handleClick = () => {
        setOpenSubMenu(!openSubMenu)
    }
    //not show the menu when not has routes
    if (navs.every((a) => a.routes?.length === 0)) return <></>
    return (
        <React.Fragment>
            <Show when={menu.requirePermission}>
                <React.Fragment>
                    <ListItemButton
                        data-testid={tid(menu.title, 'sidebargroup')}
                        sx={{
                            backgroundColor: hasOpenned
                                ? 'default.main'
                                : 'inherit',
                            padding: 1,
                        }}
                        onClick={handleClick}
                    >
                        <ListItemText
                            primaryTypographyProps={{
                                sx: {
                                    fontWeight: 700,
                                },
                            }}
                            primary={menu.title}
                        />
                        {openSubMenu ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                        {navs
                            .filter((n) => (n.routes?.length ?? 0) > 0)
                            .map((subMenu) => {
                                return (
                                    <MenuSubItem
                                        key={`nav-menu-item-${menu.title}-${subMenu.title}`}
                                        subMenu={subMenu}
                                        onClickMenu={onClickMenu}
                                        currentClient={currentClient}
                                    ></MenuSubItem>
                                )
                            })}
                    </Collapse>
                </React.Fragment>
            </Show>
        </React.Fragment>
    )
}

export default MenuGroup
